import { render } from "./SecurityTel.vue?vue&type=template&id=c5f93b4a&scoped=true"
import script from "./SecurityTel.vue?vue&type=script&lang=js"
export * from "./SecurityTel.vue?vue&type=script&lang=js"

import "./SecurityTel.vue?vue&type=style&index=0&id=c5f93b4a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f93b4a"]])

export default __exports__